/**
 * 归一化导入层级名称，用于识别 CAD 文件中常见的同名包裹根。
 *
 * 设计说明：
 * 1. SolidWorks 与部分 STEP/GLB 转换链路会给实例名追加数字后缀；
 * 2. 装配体引用外部文件时，文件根与实例名同名通常只是承载层，不应进入设计树；
 * 3. 该函数只做名称等价判断，不参与显示名称生成，避免污染用户可见文本。
 *
 * @param name 待归一化的导入层级名称。
 * @returns 用于重复根比较的稳定名称。
 */
export function normalizeImportedHierarchyDuplicateName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    // SolidWorks 实例名常见后缀：Bati.1 / Axe 1.1 / Part_1。
    .replace(/(?:\s+\d+(?:\.\d+)*)$/, '')
    .replace(/(?:[._]\d+)+$/, '')
    .trim()
}
